import { Box, Container, VStack, Text, Span } from '@bpba/ui-components';
import { Banner } from '../components/Banner';
import { Title } from '../components/Title';
import FileUploadComponent from '../components/FileUploadComponent';
import { useLocation } from "react-router-dom";
import { Info } from '../components/Info';
import { PRESTAMOPERSONAL_BANNER } from '../Constantes';
import { Label } from './FormStyles';

 interface propState {
    banner:string;
    titulo: string;
}  


export const FileUploadPage: React.FC = () => {

   const location = useLocation();
  let { banner, titulo } = location.state as propState;

    return (
        <Container>
        
                <VStack mb={"40px"}>
                    <Banner borderRadius={['0px', '8px']} url={banner} />
                    <Box flexDirection={['column', 'row']}>
                        <Box>
                            <VStack width={'100%'} p={['24px 16px', null, null, '32px 50px']}>
                                <Title title={'Documentación adjunta - ' + titulo } ></Title>
                            </VStack>
                        </Box>
                        <Box
                            width={["100%", "90%", "85%", "65%"]}
                            p={["50px 16px", "50px 16px", "50px 20px", "75px 40px"]} 
                            mr={["0px", "15px", "20px", "50px"]}
                            bg="secondary.2"
                            minHeight={["400px", "500px", "500px"]}>
                            <FileUploadComponent />
                        </Box>
                    </Box>
                  
                </VStack>

        </Container>

    )

}




